// src/pages/Home.js
import React from 'react';
import { Carousel, Container, Row, Col, Card } from 'react-bootstrap';
import '../styles/Home.css';
import bannerImage from '../assets/banner.jpg'; // Asegúrate de que la ruta sea correcta
import hematologiaImage from '../assets/hematologia.jpg';
import histopatologiaImage from '../assets/histopatologia.jpg';
import bacteriologiaImage from '../assets/bacteriologia.jpg';
import inmunologiaImage from '../assets/inmunologia.jpg';
import hormonasImage from '../assets/hormonas.jpg';
import parasitologiaImage from '../assets/parasitologia.jpg';
import bioRadImage from '../assets/biorad.png';
import biosystemsImage from '../assets/biosystems.png';
import orthoImage from '../assets/ortho.png';
import siemensImage from '../assets/siemens.png';
import logo from '../assets/logo1.png';

const Home = () => {
  return (
    <>
      <div className="banner">
        <img src={bannerImage} alt="Banner" className="banner-image" />
        <div className="banner-text">
        <img src={logo} alt="Logo" className="banner-image" />
          <h1>Centro Analítico de Patología</h1>
          <h2>Comprometidos con tu salud</h2>
        </div>
      </div>
      <Container className="my-5 text-center">
        <Row className="justify-content-center">
          <Col md={8} className="mb-5">
            <h2>En el Centro Analítico de Patología Clínica prestamos servicios de laboratorio desde 1990.
                Prestamos servicio de Laboratorio al Hospital Terranova las 24 hrs. del día durante todo el año.
                Realizamos Servicios Subrogados en análisis de rutina y especiales a otros laboratorios privados e institucionales.
                Contamos con personal de alta calidad técnica con infraestructura tecnológica actualizada, aunado a la honestidad y precios justos.
                Nuestros procesos actuales de operación están directamente ligados a los lineamientos y normas que exige la Secretaría de Salud NOM 007 SSA1 2008 y el ISO 15189.
            </h2>
          </Col>
        </Row>
      </Container>

      <Container className="my-5">
        <Carousel className="custom-carousel">
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={hematologiaImage} alt="Hematología" />
            <Carousel.Caption className="carousel-caption">
              <h3>Hematología</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={histopatologiaImage} alt="Histopatología" />
            <Carousel.Caption className="carousel-caption">
              <h3>Histopatología</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={bacteriologiaImage} alt="Bacteriología" />
            <Carousel.Caption className="carousel-caption">
              <h3>Bacteriología</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={inmunologiaImage} alt="Inmunología" />
            <Carousel.Caption className="carousel-caption">
              <h3>Inmunología</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={hormonasImage} alt="Hormonas" />
            <Carousel.Caption className="carousel-caption">
              <h3>Hormonas</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 carousel-image" src={parasitologiaImage} alt="Parasitología" />
            <Carousel.Caption className="carousel-caption">
              <h3>Parasitología</h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Container>
      <Container className="my-5 text-center">
        <Row className="justify-content-center">
          <Col md={8} className="mb-5">
            <h1>Nuestros socios</h1>
            <p>
              En Centro Analítico De Patología trabajamos con una amplia variedad de marcas y proveedores de equipos y reactivos para garantizar la precisión y fiabilidad de nuestros resultados. Algunas de las marcas con las que trabajamos incluyen: Bio-Rad Laboratories, BioSystems, Ortho Clinical Diagnostics, Siemens Healthineers. Cada una de estas marcas ofrece una gama de productos y servicios para diferentes áreas de análisis, desde pruebas de química clínica y hematología hasta microbiología. Trabajamos en estrecha colaboración con estos proveedores para mantenernos al día con las últimas tecnologías y desarrollos en el campo del diagnóstico clínico y ofrecer a nuestros pacientes la mejor atención posible.
            </p>
          </Col>
        </Row>
        </Container>
        <Container className="my-5 text-center">
        <Row className="justify-content-center">
          <Col md={4} className="my-3">
            <Card className="h-100">
              <a href="https://www.bio-rad.com/" target="_blank" rel="noopener noreferrer">
                <Card.Img variant="top" src={bioRadImage} />
              </a>
            </Card>
          </Col>
          <Col md={4} className="my-3">
            <Card className="h-100">
              <a href="https://biosystems.global/es/" target="_blank" rel="noopener noreferrer">
                <Card.Img variant="top" src={biosystemsImage} />
              </a>
            </Card>
          </Col>
          <Col md={4} className="my-3">
            <Card className="h-100">
              <a href="https://www.quidelortho.com/" target="_blank" rel="noopener noreferrer">
                <Card.Img variant="top" src={orthoImage} />
              </a>
            </Card>
          </Col>
          <Col md={4} className="my-3">
            <Card className="h-100">
              <a href="https://www.siemens-healthineers.com/" target="_blank" rel="noopener noreferrer">
                <Card.Img variant="top" src={siemensImage} />
              </a>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
